import React, { useState, useEffect } from 'react';

const StatsSection = () => {
  const [productCount, setProductCount] = useState(0);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch('/api/products');
        const data = await response.json();
        setProductCount(data.length);
      } catch (error) {
        console.error('Error fetching product count', error);
      }
    };
    fetchProducts();
  }, []);

  // Calculate dynamic stats
  const launchDate = new Date('2026-06-25').getTime();
  const now = new Date().getTime();
  const daysSinceLaunch = Math.max(0, Math.floor((now - launchDate) / (1000 * 60 * 60 * 24)));
  
  // Custom algos starts at 74 and grows by ~1 per day
  const customAlgos = 74 + Math.floor(daysSinceLaunch * 1.2);
  
  // Win rate starts at 83.7 and grows slowly
  const winRate = (83.7 + (daysSinceLaunch * 0.033)).toFixed(1);

  return (
    <section className="relative py-16 mt-8 z-20 bg-surface-container-lowest/80 backdrop-blur-md border-y border-white/5 reveal-on-scroll stats-grid">
      <div className="max-w-container-max mx-auto px-margin-mobile md:px-margin-desktop">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {/* Card 1 */}
          <div className="group relative overflow-hidden flex items-center p-8 rounded-2xl bg-surface-container-low border border-white/5 hover:border-primary/40 hover:-translate-y-2 transition-all duration-300 shadow-xl hover:shadow-[0_15px_40px_-15px_rgba(240,185,11,0.3)] stagger-item">
            <div className="absolute inset-0 bg-gradient-to-r from-primary/0 via-primary/5 to-primary/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            
            <div className="relative z-10 w-16 h-16 rounded-xl bg-primary/10 flex items-center justify-center text-primary border border-primary/20 shadow-[0_0_20px_rgba(240,185,11,0.2)] mr-6 group-hover:scale-110 transition-transform duration-300">
              <span className="material-symbols-outlined text-3xl">format_list_bulleted</span>
            </div>
            <div className="relative z-10">
              <div className="font-display-lg text-4xl font-bold text-gradient-gold mb-1">{productCount > 0 ? productCount : '15+'}</div>
              <div className="text-xs font-bold tracking-widest text-on-surface-variant uppercase">Total EAs Listed</div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="group relative overflow-hidden flex items-center p-8 rounded-2xl bg-surface-container-low border border-white/5 hover:border-secondary/40 hover:-translate-y-2 transition-all duration-300 shadow-xl hover:shadow-[0_15px_40px_-15px_rgba(4,217,163,0.3)] stagger-item">
            <div className="absolute inset-0 bg-gradient-to-r from-secondary/0 via-secondary/5 to-secondary/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            
            <div className="relative z-10 w-16 h-16 rounded-xl bg-secondary/10 flex items-center justify-center text-secondary border border-secondary/20 shadow-[0_0_20px_rgba(4,217,163,0.2)] mr-6 group-hover:scale-110 transition-transform duration-300">
              <span className="material-symbols-outlined text-3xl">code</span>
            </div>
            <div className="relative z-10">
              <div className="font-display-lg text-4xl font-bold text-white group-hover:text-secondary transition-colors duration-300 mb-1">{customAlgos}+</div>
              <div className="text-xs font-bold tracking-widest text-on-surface-variant uppercase">Custom Algos Built</div>
            </div>
          </div>

          {/* Card 3 */}
          <div className="group relative overflow-hidden flex items-center p-8 rounded-2xl bg-surface-container-low border border-white/5 hover:border-surface-tint/40 hover:-translate-y-2 transition-all duration-300 shadow-xl hover:shadow-[0_15px_40px_-15px_rgba(164,198,255,0.3)] stagger-item">
            <div className="absolute inset-0 bg-gradient-to-r from-surface-tint/0 via-surface-tint/5 to-surface-tint/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            
            <div className="relative z-10 w-16 h-16 rounded-xl bg-surface-tint/10 flex items-center justify-center text-surface-tint border border-surface-tint/20 shadow-[0_0_20px_rgba(164,198,255,0.2)] mr-6 group-hover:scale-110 transition-transform duration-300">
              <span className="material-symbols-outlined text-3xl">trending_up</span>
            </div>
            <div className="relative z-10">
              <div className="font-display-lg text-4xl font-bold text-white group-hover:text-surface-tint transition-colors duration-300 mb-1">{winRate}%</div>
              <div className="text-xs font-bold tracking-widest text-on-surface-variant uppercase">Avg Backtest Win Rate</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
